var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.credentialsNecessary)?_c('div',{staticClass:"form-container"},[_c('Logo',{staticClass:"form-header-logo"}),_c('LoginForm',{attrs:{"forwardAfterQuery":_vm.forwardAfterQuery,"spoofing":false,"busy":_vm.busy},on:{"login":_vm.save}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }